"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "body-wrapper" };
const _hoisted_2 = { class: "oplus-table-wrapper" };
const _hoisted_3 = { class: "oplus-table table" };
const _hoisted_4 = { class: "year-selector-cell column-sticky" };
const _hoisted_5 = ["value"];
const _hoisted_6 = ["value"];
const _hoisted_7 = { class: "month-title input-col" };
const _hoisted_8 = { class: "input-col input-cell" };
const _hoisted_9 = ["onUpdate:modelValue", "placeholder"];
const _hoisted_10 = { class: "flex-normal" };
const vue_3 = require("vue");
const settings_js_1 = require("../js/settings.js");
const Modal_vue_1 = __importDefault(require("./Modal.vue"));
const common_1 = require("../common/common");
const MONTH_IN_A_YEAR = 12;
exports.default = (0, vue_1.defineComponent)({
    __name: 'MaxLaborPerMonthModal',
    props: {
        groupId: {},
        userId: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const isVisible = (0, vue_3.ref)(false);
        const isLoading = (0, vue_3.ref)(false);
        const rawYearMonthMaxLaborTextValue = (0, vue_3.ref)({});
        const selectedYearTextValues = (0, vue_3.ref)(Array(MONTH_IN_A_YEAR).fill(''));
        const CURRENT_YEAR = new Date().getFullYear();
        const selectedYear = (0, vue_3.ref)(CURRENT_YEAR);
        const placeholder = (0, vue_3.ref)("HH:MM");
        function openModal() {
            isVisible.value = true;
        }
        function closeModal() {
            isLoading.value = false;
            isVisible.value = false;
        }
        __expose({
            openModal,
            closeModal,
        });
        async function onConfirm() {
            isLoading.value = true;
            try {
                await postBranchDefaultsMaxMonthLaborRequestAndPopulate();
                (0, settings_js_1.importAlertModal)().alertSuccess("設定を更新しました！");
            }
            catch {
                (0, settings_js_1.importAlertModal)().alert("エラーが発生しました。恐れ入りますが、再度お試しください。");
            }
            finally {
                isLoading.value = false;
            }
        }
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? 'confirm-btn-loading loading' : '';
        });
        async function fetchAndPopulateBranchDefaultsMaxMonthLabor(year) {
            try {
                let res;
                const searchParams = new URLSearchParams(window.location.search);
                const companyId = searchParams.get("c");
                if (props.userId && companyId) {
                    res = await fetch(`/api/v2/branch_user_max_month_labor/${companyId}?year=${year}&userId=${props.userId}`);
                }
                else {
                    res = await fetch(`/api/v2/branch_defaults_max_month_labor/${props.groupId}?year=${year}`);
                }
                const json = await res.json();
                if (json?.result) {
                    rawYearMonthMaxLaborTextValue.value[year] = Array(MONTH_IN_A_YEAR).fill('');
                    for (let i = 0; i < MONTH_IN_A_YEAR; i++) {
                        const maxLaborKitchenTime = (0, common_1.parseMaxMonthLaborMinutesRaw)(json?.result?.[i]);
                        selectedYearTextValues.value[i] = maxLaborKitchenTime;
                        rawYearMonthMaxLaborTextValue.value[year][i] = maxLaborKitchenTime;
                    }
                }
                if (json?.default) {
                    placeholder.value = (0, common_1.parseMaxMonthLaborMinutesRaw)(json.default);
                }
            }
            catch {
                clearAllEntries();
            }
        }
        async function handleSelectChange() {
            await fetchAndPopulateBranchDefaultsMaxMonthLabor(selectedYear.value);
        }
        async function postBranchDefaultsMaxMonthLaborRequestAndPopulate() {
            const body = {
                year: selectedYear.value,
                values: selectedYearTextValues.value,
            };
            let res;
            const searchParams = new URLSearchParams(window.location.search);
            const companyId = searchParams.get("c");
            if (props.userId && companyId) {
                res = await fetch(`/api/v2/branch_user_max_month_labor/${companyId}?userId=${props.userId}`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });
            }
            else {
                res = await fetch(`/api/v2/branch_defaults_max_month_labor/${props.groupId}`, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(body),
                });
            }
            if (!res.ok) {
                throw new Error();
            }
            const json = await res.json();
            // repopulate values since backend reformats it
            const yearItem = Array(MONTH_IN_A_YEAR).fill('');
            rawYearMonthMaxLaborTextValue.value[selectedYear.value] = yearItem;
            selectedYearTextValues.value = Array(MONTH_IN_A_YEAR).fill('');
            for (let i = 0; i < MONTH_IN_A_YEAR; i++) {
                const maxLaborKitchenTime = (0, common_1.parseMaxMonthLaborMinutesRaw)(json?.result?.[i]);
                selectedYearTextValues.value[i] = maxLaborKitchenTime;
                yearItem[i] = maxLaborKitchenTime;
            }
        }
        function clearAllEntries() {
            selectedYearTextValues.value = Array(MONTH_IN_A_YEAR).fill('');
        }
        (0, vue_3.onMounted)(async () => {
            await fetchAndPopulateBranchDefaultsMaxMonthLabor(CURRENT_YEAR);
        });
        return (_ctx, _cache) => {
            return (isVisible.value)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Modal_vue_1.default, {
                    key: 0,
                    onCloseModal: closeModal,
                    onConfirm: onConfirm,
                    class: "branch-default-max-labor-modal"
                }, {
                    "header-title": (0, vue_2.withCtx)(() => [...(_cache[2] || (_cache[2] = [
                            (0, vue_2.createElementVNode)("span", { class: "max-labor-modal-title align-center flex-gap" }, " 各月ごとに労働時間の上限を設定する ", -1 /* CACHED */)
                        ]))]),
                    content: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_1, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, [
                                (0, vue_2.createElementVNode)("table", _hoisted_3, [
                                    (0, vue_2.createElementVNode)("thead", null, [
                                        (0, vue_2.createElementVNode)("tr", null, [
                                            (0, vue_2.createElementVNode)("td", _hoisted_4, [
                                                (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("select", {
                                                    onChange: _cache[0] || (_cache[0] = ($event) => (handleSelectChange())),
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((selectedYear).value = $event)),
                                                    class: "year-selector form-select"
                                                }, [
                                                    (0, vue_2.createElementVNode)("option", { value: (0, vue_2.unref)(CURRENT_YEAR) }, (0, vue_2.toDisplayString)((0, vue_2.unref)(CURRENT_YEAR)), 9 /* TEXT, PROPS */, _hoisted_5),
                                                    (0, vue_2.createElementVNode)("option", {
                                                        value: (0, vue_2.unref)(CURRENT_YEAR) + 1
                                                    }, (0, vue_2.toDisplayString)((0, vue_2.unref)(CURRENT_YEAR) + 1), 9 /* TEXT, PROPS */, _hoisted_6)
                                                ], 544 /* NEED_HYDRATION, NEED_PATCH */), [
                                                    [vue_2.vModelSelect, selectedYear.value]
                                                ])
                                            ]),
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(MONTH_IN_A_YEAR, (month) => {
                                                return (0, vue_2.createElementVNode)("td", _hoisted_7, (0, vue_2.toDisplayString)(month) + "月 ", 1 /* TEXT */);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("tbody", null, [
                                        (0, vue_2.createElementVNode)("tr", null, [
                                            _cache[3] || (_cache[3] = (0, vue_2.createElementVNode)("td", { class: "column-sticky no-bottom-border" }, null, -1 /* CACHED */)),
                                            ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(MONTH_IN_A_YEAR, (month) => {
                                                return (0, vue_2.createElementVNode)("td", _hoisted_8, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": ($event) => ((selectedYearTextValues.value[month - 1]) = $event),
                                                        type: "text",
                                                        placeholder: placeholder.value,
                                                        class: "form-input text-center value-input"
                                                    }, null, 8 /* PROPS */, _hoisted_9), [
                                                        [vue_2.vModelText, selectedYearTextValues.value[month - 1]]
                                                    ])
                                                ]);
                                            }), 64 /* STABLE_FRAGMENT */))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    "footer-btn": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "oplus-modal-btn clear-btn",
                                onClick: clearAllEntries
                            }, "クリア"),
                            (0, vue_2.createElementVNode)("button", {
                                class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-confirm-btn"]),
                                onClick: onConfirm
                            }, "確定", 2 /* CLASS */)
                        ])
                    ]),
                    _: 1 /* STABLE */
                }))
                : (0, vue_2.createCommentVNode)("v-if", true);
        };
    }
});
